import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { FDataGrid, FGridMoneyCell } from '../grid';

type Props = {
  rows: any[];
  loading?: boolean;
};

class BudgetConsolidationAccountGrid extends React.Component<Props> {
  columns: GridColDef[] = [
    { field: 'accountcode', headerName: 'Account', width: 130 },
    { field: 'accountname', headerName: 'Account Name', flex: 1, minWidth: 280 },
    { field: 'activitybudget', headerName: 'Activity', width: 150, renderCell: FGridMoneyCell },
    { field: 'directbudget', headerName: 'Direct', width: 150, renderCell: FGridMoneyCell },
    { field: 'investmentbudget', headerName: 'Investment', width: 150, renderCell: FGridMoneyCell },
    { field: 'totalbudget', headerName: 'Total', width: 160, renderCell: FGridMoneyCell },
  ];

  render() {
    return (
      <FDataGrid
        title="Consolidation by Account"
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={520}
        showQuickFilter
        toolbarSx={{ backgroundColor: '#eaf2fb' }}
        getRowId={(row: any) => row.accountid || row.accountcode}
        pageSizeOptions={[25, 50, 100]}
        initialState={{
          pagination: { paginationModel: { pageSize: 25 } },
        }}
      />
    );
  }
}

export default BudgetConsolidationAccountGrid;
